import {lazy} from 'react';
import {Navigate, type RouteObject} from 'react-router-dom';

import AdminRouteGuard from '@/components/admin/common/AdminRouteGuard';
import popupRoutes from '@/routes/admin/popup.routes.tsx';
import PrivateRoute from '@/routes/private.routes';
import withSuspense from '@/routes/withSuspense';

import boardRoutes from './board.routes';
import contentsRoutes from './contents.routes';
import extRoutes from './ext.routes';
import logRoutes from './log.routes';
import mapRoutes from './map.routes';
import statisticsRoutes from './statistics.routes';
import updateRoutes from './update.routes';
import userRoutes from './user.routes';

const Mngt = lazy(() => import('@/pages/mngt/Mngt'));

const mngtRoutes: RouteObject[] = [
  {
    path: '/mngt',
    element: (
      <AdminRouteGuard>
        <PrivateRoute />
      </AdminRouteGuard>
    ),
    children: [
      {
        path: '',
        element: withSuspense(<Mngt />),
        children: [
          {
            index: true,
            element: <Navigate to="contents" replace />
          },
          // {
          //   path: 'dashboard',
          //   element: withSuspense(<Dashboard />)
          // },
          ...contentsRoutes,
          ...mapRoutes,
          ...userRoutes,
          ...updateRoutes,
          ...extRoutes,
          ...logRoutes,
          ...boardRoutes,
          ...statisticsRoutes,
          ...popupRoutes
        ]
      }
    ]
  }
];

export default mngtRoutes;
